/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Source_GroupInputs */

const en_source_group = /** @type {(inputs: Source_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source Group`)
};

const fr_source_group = /** @type {(inputs: Source_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupe source`)
};

const de_source_group = /** @type {(inputs: Source_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quellengruppe`)
};

const it_source_group = /** @type {(inputs: Source_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppo di origine`)
};

const ru_source_group = /** @type {(inputs: Source_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Группа источников`)
};

const es_source_group = /** @type {(inputs: Source_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo fuente`)
};

const zh_cn2_source_group = /** @type {(inputs: Source_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`来源组`)
};

const ja_source_group = /** @type {(inputs: Source_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ソースグループ`)
};

const hi_source_group = /** @type {(inputs: Source_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्रोत समूह`)
};

const pt_pt2_source_group = /** @type {(inputs: Source_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de origem`)
};

/**
* | output |
* | --- |
* | "Source Group" |
*
* @param {Source_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const source_group = /** @type {((inputs?: Source_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Source_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_source_group(inputs)
	if (locale === "de") return de_source_group(inputs)
	if (locale === "it") return it_source_group(inputs)
	if (locale === "ru") return ru_source_group(inputs)
	if (locale === "es") return es_source_group(inputs)
	if (locale === "zh-CN") return zh_cn2_source_group(inputs)
	if (locale === "ja") return ja_source_group(inputs)
	if (locale === "hi") return hi_source_group(inputs)
	if (locale === "pt-PT") return pt_pt2_source_group(inputs)
	return en_source_group(inputs)
});